<template>
  <div class="wrapper">
    <Skeleton
      v-if="referralIdLoading"
      animation="wave"
      :height="isMobile ? '60px' : '98px'"
      class="ml-auto"
    />
    <div v-else>
      <p v-if="!referralId" class="register-text">
        {{ $t('common.airdropRegistration') }}
      </p>
      <div v-else class="ref-id">
        <p>{{ $t('common.referFor') }}</p>
        <div class="ref-id__item">
          <p>{{ displayedReferralId }}</p>
          <img
            alt="copy icon"
            height="24"
            width="24"
            src="@/assets/white-copy.png"
            @click="copyUrl"
          />
        </div>
      </div>
    </div>
    <button
      v-if="!referralId && !referralIdLoading"
      class="footer-button"
      @click="goToAirdrop"
    >
      <img
        src="@/assets/diamond.svg"
        width="28"
        height="24"
        alt="diamond"
        class="footer-button__item"
      />
      <span class="footer-button__item">{{ $t('common.airdrop') }}</span>
      <i class="pi pi-arrow-right arrow-icon" />
    </button>
    <CopyNotification ref="copyDialog" />
  </div>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue';
import Skeleton from 'primevue/skeleton';
import { useClipboard, useMediaQuery } from '@vueuse/core';
import { useStore } from '@/store';
import { AIRDROP_FE } from '@/constants';
import { CopyNotification } from '@/components/UI/CopyNotification';

const mainStore = useStore();
const { copy: onCopyUrl } = useClipboard({ legacy: true });
const copyDialog = ref();
const referralId = computed(() => mainStore.referralId.value);
const referralIdLoading = computed(() => mainStore.referralIdLoading.value);

const urlToCopy = computed(() => {
  return `${AIRDROP_FE}/?ref=${referralId.value}`;
});

const isMobile = useMediaQuery('(min-width: 1399px)');
const displayedReferralId = computed(() => {
  if (referralId.value.length > 7 && isMobile.value) {
    return `${referralId.value.slice(0, 7)}...`;
  } else {
    return `${referralId.value.slice(0, 15)}...`;
  }
});

const goToAirdrop = () => {
  window.location.href = new URL(AIRDROP_FE).href;
};

async function copyUrl() {
  await onCopyUrl(urlToCopy.value);
  copyDialog.value.show();
}
</script>
<style scoped lang="scss">
.wrapper {
  border-width: 0 1px 1px 1px;
  border-style: solid;
  border-color: rgb(128, 128, 128, 0.3);
  border-radius: 0 0 16px 16px;
  background: linear-gradient(
    90.21deg,
    rgba(58, 40, 109, 0.8) -1.25%,
    rgba(32, 28, 61, 0.8) 99.82%
  );
  width: 246px;

  @media (max-width: 1400px) {
    width: 100%;
    border-radius: 0;
  }
}
.register-text {
  padding: 0 15px 0 15px;
  font-size: 15px;
  font-weight: 500;
  line-height: 18px;

  @media (max-width: 1400px) {
    font-size: 18px;
    width: 100%;
    height: 100%;
  }
}
.footer-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  border: 0;
  border-top: 1px solid;
  width: 100%;
  margin: 0;
  color: white;
  background: linear-gradient(90deg, rgba(110, 66, 202, 0) 50%, #8d29c1 100%);
  border-radius: 0 0 16px 16px;
  border-image: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0.1) 100%,
      rgba(255, 255, 255, 0.1) 100%
    )
    1;
  font-size: 15px;
  font-weight: 500;
  line-height: 17.58px;
  letter-spacing: 0.07em;
  cursor: pointer;

  &__item {
    text-transform: uppercase;
  }

  @media (max-width: 1400px) {
    justify-content: flex-start;
    border-radius: 0;
  }
}

.ref-id {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
  padding: 0 15px 0 15px;
  border-radius: 0 0 16px 16px;
  background: linear-gradient(90deg, rgba(110, 66, 202, 0) 50%, #8d29c1 100%);

  font-size: 15px;
  font-weight: 500;
  line-height: 18px;

  &__item {
    display: flex;
    align-items: center;
    gap: 5px;
  }

  @media (max-width: 1400px) {
    height: 60px;
    width: 100%;
    border-radius: 0;
  }
}

.arrow-icon {
  position: absolute;
  right: 0;
  padding: 20px;
}
</style>
